var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderSkin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "placeholder_skin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "28.6178659%",
    fx: "50%",
    fy: "28.6178659%",
    r: "152.380952%",
    gradientTransform: "translate(0.500000,0.286179),scale(1.000000,0.656250),rotate(90.000000),translate(-0.500000,-0.286179)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "placeholder_skin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    fill: "url(#radialGradient-1)",
    x: 19.5,
    y: 2.5,
    width: 62,
    height: 95,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7113821,83 L69.7113821,81.8239845 C69.803523,81.205029 70.0281165,80.6892328 70.3851626,80.2765957 C70.7422087,79.8639587 71.151084,79.4977434 71.6117886,79.1779497 C72.0724932,78.858156 72.5619919,78.5383623 73.0802846,78.2185687 C73.5985772,77.898775 74.0707995,77.5119278 74.4969512,77.0580271 C74.923103,76.6041264 75.2801491,76.0573823 75.5680894,75.417795 C75.8560298,74.7782076 76,73.9632495 76,72.9729207 C76,72.374597 75.8560298,71.7298517 75.5680894,71.0386847 C75.2801491,70.3475177 74.802168,69.7027724 74.1341463,69.1044487 C73.4661247,68.5061251 72.5850271,68.0058027 71.4908537,67.6034816 C70.3966802,67.2011605 69.0318428,67 67.3963415,67 C66.1294038,67 64.9834011,67.1908446 63.9583333,67.5725338 C62.9332656,67.9542231 62.0579268,68.4854932 61.3323171,69.1663443 C60.6067073,69.8471954 60.0423442,70.6518375 59.6392276,71.5802708 C59.2361111,72.5087041 59.0230352,73.5299807 59,74.6441006 L64.0792683,74.6441006 C64.0792683,74.0870406 64.148374,73.5660864 64.2865854,73.0812379 C64.4247967,72.5963894 64.6378726,72.1734365 64.925813,71.8123791 C65.2137534,71.4513217 65.5823171,71.1624758 66.0315041,70.9458414 C66.4806911,70.729207 67.0162602,70.6208897 67.6382114,70.6208897 C68.5596206,70.6208897 69.2794715,70.8478401 69.7977642,71.3017408 C70.3160569,71.7556415 70.5752033,72.4571244 70.5752033,73.4061896 C70.5982385,73.9632495 70.4888211,74.4274662 70.2469512,74.7988395 C70.0050813,75.1702128 69.6883469,75.5106383 69.296748,75.8201161 C68.9051491,76.1295938 68.4789973,76.4390716 68.0182927,76.7485493 C67.5575881,77.0580271 67.1199187,77.4242424 66.7052846,77.8471954 C66.2906504,78.2701483 65.9278455,78.7807866 65.6168699,79.3791103 C65.3058943,79.9774339 65.1158537,80.7201805 65.046748,81.6073501 L65.046748,83 L69.7113821,83 Z M70,91 L70,85 L65,85 L65,91 L70,91 Z",
    id: "?",
    fillOpacity: 0.221345061,
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderSkin);
export default __webpack_public_path__ + "static/media/placeholder_skin.0623edf9bbaf461bdffdda223696bf82.svg";
export { ForwardRef as ReactComponent };